import Chart from "../../../node_modules/chart.js/dist/chart.js";
import HSSideNav from "../theme/aside.min"

var oSTable = null;
document.addEventListener("turbolinks:before-cache", function() {
    if (oSTable !== null) {
        oSTable.destroy()
        oSTable = null
    }
    $("select.select2-hidden-accessible").select2('destroy');
})

$(document).on('turbolinks:load', function () {
    const radioButtons = document.querySelectorAll('.survey-radio');
    radioButtons.forEach(radio => {
        radio.addEventListener('click', function() {
            const selectedRadio = document.querySelector('.survey-radio:checked');
            if (selectedRadio) {
                const selectedCategoryId = selectedRadio.value;
                let arr = JSON.parse(selectedRadio.dataset.category);
                let filtered = arr.filter(item => item && item !== selectedCategoryId)

                if (filtered) {
                    $(".js-validation").each(function() {
                        if (!$(this).hasClass('survey-question')) {
                            $(this).addClass('survey-question');
                        }
                    });
                    filtered.forEach(catId => {
                        $(".category-id-" + catId).removeClass('survey-question');
                    });
                }
            }
        });
    });
    // new HSSideNav('.js-navbar-vertical-aside').init()
    setSidebarClass()
    // const body = document.getElementsByTagName('body')[0],
    //     isMini = window.localStorage.getItem('hs-navbar-vertical-aside-mini') === null ? false : window.localStorage.getItem('hs-navbar-vertical-aside-mini');
    //
    // if (isMini) {
    //     body.classList.add('navbar-vertical-aside-mini-mode')
    // }
    function toggleBlock(checkboxSelector, blockClass) {
        if ($(checkboxSelector).is(":checked")) {
            $(blockClass).removeClass('d-none');
        } else {
            $(blockClass).addClass('d-none');
        }
    }

    toggleBlock('#subscription', '.subscription-block');
    toggleBlock('#course', '.course-block');
    toggleBlock('#product', '.product-block');

    $(document).on("change", "#subscription", function () {
      toggleBlock(this, '.subscription-block');
    });

    $(document).on("change", "#course", function () {
      toggleBlock(this, '.course-block');
    });

    $(document).on("change", "#product", function () {
      toggleBlock(this, '.product-block');
    });
    
    $(document).on("change", "#vat-setting-toggle", function () {
        const selectedValue = $(this).val(); 
        const vatFieldContainer = $("#vat-number-charge-container");
        if (selectedValue === "yes" || selectedValue === "both") {
          vatFieldContainer.removeClass("d-none");
        } else {
          vatFieldContainer.addClass("d-none");
        }
    }); 

    document.addEventListener("click", function (event) {
        let button = event.target.closest(".js-copy-btn");
        if (button) {
            let url = button.dataset.url;
            let msg = button.nextElementSibling;
            navigator.clipboard.writeText(url).then(() => {
                msg.classList.remove("d-none"); 
                setTimeout(() => msg.classList.add("d-none"), 3000); 
            });
        }
    });

    $(document).on('click', '[data-locale]', function(event) {
        event.preventDefault();
      
        const $btn = $(this);
        const locale = $btn.data('locale');
        const resourceId = $btn.data('resource-id') || 'new';
        const resourceType = $btn.data('resource-type');
        const partialName = 'form_for_language'; 
        const surveyPositionId = $('#survey_position_id_for_nl').val();
        const surveyCategoryId = $('#survey_category_id_for_nl').val()
        const onlineCourseId = $('#online_course_for_nl').val();
      
        $.ajax({
            url: `/switch_locale_tabs/${resourceType}/${resourceId}`,
            method: 'POST',
            data: {
              locale: locale,
              partial_name: partialName,
              survey_position_id: surveyPositionId,
              online_course_id: onlineCourseId,
              survey_category_id: surveyCategoryId
            }
        });
    });

    window.safeReinitializeSelect2 = function ($element, parent) {
        if (!$element.length || !$element.is('select')) {
            console.warn("Invalid element passed to select2 initializer:", $element);
            return;
        }
        try {
            if ($element.hasClass('select2-hidden-accessible')) {
                $element.select2('destroy');
                $element.nextAll('.select2-container').remove();
            }

            $element.select2({
                width: '100%',
                dropdownParent: parent,
                dropdownAutoWidth: true,
                placeholder: "Select",
                allowClear: true
            });
        } catch (e) {
            console.error("Select2 init failed:", e);
        }
    };

    $(document).on('shown.bs.tab', 'button[data-bs-toggle="pill"]', function (e) {
        const $modal = $('#adminModal3');
        const $tabPane = $($(e.target).data('bsTarget'));
        $tabPane.find('select.select2').each(function () {
            window.safeReinitializeSelect2($(this), $modal);
        });
    });

    $(document).on('cocoon:after-insert', '#qus-choices-wrapper', function (e, insertedItem) {
        const $modal = $('#adminModal3');
        insertedItem.find('select.select2').each(function () {
            window.safeReinitializeSelect2($(this), $modal);
        });
    });
      
    function updateComparisonOptions(modalId) {
        const $modal = $(modalId);
        const selectedProductVal = $modal.find('.checkout_form_checkout_item_ids_product').val();
        const selectedProduct = selectedProductVal ? selectedProductVal.match(/\d+/)?.[0] : null;
      
        const selectedPlanVal = $modal.find('.checkout_form_checkout_item_ids_plan').val();
        const selectedPlan = selectedPlanVal ? selectedPlanVal.match(/\d+/)?.[0] : null;
      
        const $comparisonProduct = $modal.find('.checkout_form_checkout_item_ids_comparison_product_1');
      
        $comparisonProduct.find('option').each(function () {
          const val = $(this).val();
          const optionValue = val ? val.match(/\d+/)?.[0] : null;
          if (optionValue === selectedProduct) {
            $(this).prop('disabled', true).hide();
          } else {
            $(this).prop('disabled', false).show();
          }
        });
      
        window.safeReinitializeSelect2($comparisonProduct, $modal);
      
        const $comparisonPlan = $modal.find('.checkout_form_checkout_item_ids_comparison_plan_1');
      
        $comparisonPlan.find('option').each(function () {
          const val = $(this).val();
          const optionValue = val ? val.match(/\d+/)?.[0] : null;
          if (optionValue === selectedPlan) {
            $(this).prop('disabled', true).hide();
          } else {
            $(this).prop('disabled', false).show();
          }
        });
      
        window.safeReinitializeSelect2($comparisonPlan, $modal);
    }

    $(document).on('shown.bs.modal', '#adminModal3', function () {
        const $modal = $(this);
        const $activeTab = $modal.find('.tab-pane.active');
        $activeTab.find('select.select2').each(function () {
            window.safeReinitializeSelect2($(this), $modal);
        });

        $modal.find("select.select2").each(function () {
          window.safeReinitializeSelect2($(this), $modal);
        });

        const $config = $modal.find('#vwd-config');
        const apiUrl = $config.data('vwd-api-url');
        const apiKey = $config.data('vwd-api-key');
        initializeFlatpickr();
        initializeAdminModal3Content($modal);
        updateComparisonOptions($modal);
      
        $modal.find('.checkout_form_checkout_item_ids_product, .checkout_form_checkout_item_ids_plan').off('change')
        .on('change', function () {
            updateComparisonOptions($modal);
        });
      
        $modal.find(".vwd-feed").select2({
          width: '100%',
          dropdownParent: $modal,
          ajax: {
            headers: { ApiKey: apiKey },
            dataType: 'json',
            delay: 250,
            url: function (params) {
              return apiUrl + "Search/" + encodeURIComponent(params.term || '');
            },
            processResults: function (data) {
              return {
                results: data.map(function (item) {
                  return {
                    id: item.IssueID,
                    text: `${item.Name} (${item.Type}, ${item.ISINCode}, ${item.Market})`
                  };
                })
              };
            },
            cache: true
          },
          minimumInputLength: 1
        });

    });  
    
    $(document).on("change", ".duration_unit_select", function (e) {
        e.preventDefault();
        let selectedValue = $(this).val(); 
        let $expirationField = $(this).closest('form').find('.expiration_date_field');
        if (selectedValue === "till") {
        $expirationField.show();
        } else {
        $expirationField.hide();
        }
    });

    function initializeAdminModal3Content($modal) {

        const keyPointsInput = $modal.find('.checkout_form_key_points');
        let rawValue = keyPointsInput.val();
        try {
          rawValue = JSON.parse(rawValue);
          if (Array.isArray(rawValue)) {
            rawValue = rawValue.join(',');
          }
        } catch (e) {
        }
        keyPointsInput.val(rawValue); 
        keyPointsInput.tagsinput('refresh');
        if (typeof rawValue === 'string' && rawValue.trim() !== '') {
            rawValue.split(',').forEach(tag => keyPointsInput.tagsinput('add', tag.trim()));
        }
        keyPointsInput.parent().find('.bootstrap-tagsinput').addClass('form-control');
    }
      
    $(document).on('input', '.checkout-name', function () {
        $('.url-form').val($(this).val().trim().toLowerCase());
    });
     
    $(document).on('click', '#copy-btn', function (e) {
        e.preventDefault();
      
        const $inputGroup = $(this).closest('.input-group');
        const $urlField = $inputGroup.find('.url-form');
        const inputValue = $urlField.val().trim();
      
        if (!inputValue) {
          alert('Please enter a URL before copying.');
          return;
        }
      
        const baseURL = $inputGroup.data('base-url');
        const fullURL = baseURL + inputValue;
      
        navigator.clipboard.writeText(fullURL).then(() => {
          const $copiedMessage = $inputGroup.closest('.form-group').find('.copied-message');
          $copiedMessage.text('Checkout URL Copied.').removeClass('d-none');
          setTimeout(() => {
            $copiedMessage.addClass('d-none');
          }, 2000);
        }).catch((err) => {
          console.error('Copy failed', err);
          alert('Failed to copy. Please try manually.');
        });
    });
      
    function initSurvey() {
        let totalQuestions = $(".survey-question").length;
        if (totalQuestions === 0) {
            setTimeout(initSurvey, 500);
            return;
        }
        let currentIndex = 0;
        function showQuestion(index) {
            $(".survey-question").addClass("d-none");
            $(".survey-question").eq(index).removeClass("d-none");
            $(".prev-btn").toggle(index > 0);
            $(".next-btn").toggle(index < totalQuestions - 1);
            $(".next-btn_survey").toggle(index < totalQuestions - 1);
            $("#submit-btn").toggleClass("d-none", index !== totalQuestions - 1);
        }
        function isOptionSelected(index) {
            let currentQuestion = $(".survey-question").eq(index);
            let radioChecked = currentQuestion.find("input[type='radio']:checked").length > 0;
            let dateInput = currentQuestion.find("input.set-date");
            let dateFilled = dateInput.length > 0 && dateInput[0].value.trim() !== "";
            return radioChecked || dateFilled;
        }
        showQuestion(currentIndex);
        $(document).off("click", ".next-btn_survey").on("click", ".next-btn_survey", function () {
            if (currentIndex < totalQuestions - 1) {
                currentIndex++;
                showQuestion(currentIndex);
            }
        });
        $(document).off("click", ".next-btn").on("click", ".next-btn", function () {
            if (!isOptionSelected(currentIndex)) {
                alert("Please select an option before proceeding.");
                return;
            }
            if (currentIndex < totalQuestions - 1) {
                currentIndex++;
                showQuestion(currentIndex);
                totalQuestions = $(".survey-question").length;
            }
        });
        $(document).off("click", ".prev-btn").on("click", ".prev-btn", function () {
            if (currentIndex > 0) {
                currentIndex--;
                showQuestion(currentIndex);
            }
        });
    }
    
    initSurvey();

    // ticket image and video preview code 
    function previewFiles(input, type) {
        var previewContainer = $("#preview-container");
        previewContainer.html("");
    
        if (input.files) {
          $.each(input.files, function(i, file) {
            var reader = new FileReader();
            reader.onload = function(e) {
              var previewElement;
              if (type === "image") {
                previewElement = $("<img>").attr("src", e.target.result).addClass("img-thumbnail m-1").css({
                  width: "100px",
                  height: "100px"
                });
              } else if (type === "video") {
                previewElement = $("<video>").attr("src", e.target.result).prop("controls", true).addClass("m-1").css({
                  width: "150px",
                  height: "100px"
                });
              }
              previewContainer.append(previewElement);
            };
            reader.readAsDataURL(file);
          });
        }
    }
    
    $(document).on("change", "#image-upload", function() {
      previewFiles(this, "image");
    });
    
    $(document).on("change", "#video-upload", function() {
      previewFiles(this, "video");
    });

    // saleorder inside payment select aleart code

    $(document).on("submit", ".sales_order_edit_user", function(event) {
        let paymentSelect = $("select[name*='[payment_method]']");
        let errorDiv = $(".payment-method-error");
        let isValid = paymentSelect.val() && paymentSelect.val().trim() !== ""; 
    
        if (!isValid) {
          event.preventDefault();
          errorDiv.text("Please select a payment method.").removeClass("d-none");
          setTimeout(() => {
            errorDiv.addClass("d-none");
          }, 1000);
          return false;
        } else {
          errorDiv.addClass("d-none");
        }
    });
    
    $(document).on("click", ".survey-position, .survey-option", function() {
        $(".survey-position, .survey-option").removeClass("bg-primary text-white"); 
        $(this).addClass("bg-primary text-white"); 
        $(this).find("input[type='radio']").prop("checked", true); 
    });
    

    $(document).on("click", ".padlock-image", function () { 
       $(this).closest("form").submit();
    });

    $(document).on("click", ".comparison-toggle", function () {
        const $checkbox = $(this);
        const checkoutFormId = $checkbox.closest(".comparison").data("checkout-form-id");
        const flagId = $checkbox.data("flag-id");
        const isSelected = $checkbox.prop("checked");
        $.ajax({
            url: `/toggle_comparison_flag`,
            type: "POST",
            dataType: "json",
            headers: {
                "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
            },
            data: {
                checkout_form_id: checkoutFormId,
                flag_id: flagId,
                selected: isSelected,
            }
        });
        location.reload();
    });

    document.querySelectorAll(".dynamic-border").forEach((input) => {
        const borderColor = input.getAttribute("data-border-color");
        input.addEventListener("focus", () => {
            input.style.borderColor = borderColor;
            input.style.setProperty("border-color", borderColor, "important");
        });
        input.addEventListener("blur", () => {
            input.style.borderColor = "";
            input.style.removeProperty("border-color");
        });              
    });

    document.querySelectorAll("input.select-settings-tabs").forEach(radio =>
        radio.addEventListener("change", () => radio.checked && (window.location.href = radio.dataset.url))
    ); 
    const euroFormatter = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' });
    const calculateTotalPrice = () => {
        let totalPrice = 0;
        $(".plan-price-cents, .course-price-cents, .product-price-cents").each(function () { 
            totalPrice += parseInt($(this).val().replace(/[^0-9]/g, '')) || 0;  
        });
        $("#total-price-display").text(euroFormatter.format(totalPrice / 100));
    };

    $(document).on("input", ".plan-price-cents, .course-price-cents, .product-price-cents", function () {
        let rawValue = $(this).val().replace(/[^0-9]/g, '');
        let numericValue = parseInt(rawValue) || 0;
        $(this).data('raw-value', numericValue);
        $(this).val(euroFormatter.format(numericValue / 100));
        calculateTotalPrice();
    });

    $(document).on("change", ".sales_order_line_select", function () {
        const container = $(this).closest("[data-price-mapping]");
        const pricesData = JSON.parse(container.attr("data-price-mapping"));
        const priceField = container.find("input[type='text']");
        const item = pricesData.find((p) => p.id === parseInt($(this).val(), 10));
        if (item) {
          const priceInCents = item.price_cents || 0;
          priceField.val(euroFormatter.format(priceInCents / 100));
        } else {
          priceField.val("");
        }
        calculateTotalPrice();
    });

    $(document).on("keyup", ".price-cents-field", function () {
        $(this).val($(this).val().replace(/[^0-9]/g, '').replace(/\B(?=(\d{2})+(?!\d))/g, ","));
        $(this).closest('.row').find(".continue-price-checkbox").removeClass("d-none");
    });

    $(document).on("change", "#user_sales_orders_attributes_0_payment_method", function () {
        if ($(this).val() == "free") {
            $("#total-price-display").addClass('d-none');
            $(".total-price-display").removeClass('d-none');
            $('.user_address').addClass('d-none');
            $(".total-price").removeClass('d-none');
        } else if ($(this).val() == "invoice") {
            $('.user_address').removeClass('d-none');
            $(".total-price").addClass('d-none');
        }  else if ($(this).val() == "mandate") {
            $(".total-price").removeClass('d-none');
            $("#total-price-display").removeClass('d-none');
            $(".total-price-display").addClass('d-none');
            $('.user_address').addClass('d-none');
        }
    });

    $(document).on("click", "#add-plan-btn", function (e) {
        e.preventDefault();
        const newFields = $('#plan_template').html().replace(/NEW_RECORD/g, new Date().getTime());
        $('#sales_order_line_plan').append(newFields);
        $('.remove-plan-line-btn').removeClass('d-none');
        $('#sales_order_line_plan .plan-fields').each(function(index) {
            if (index === 0) {
                $(this).find('.remove-plan-line-btn').addClass('d-none');
            } else {
                $(this).find('.remove-plan-line-btn').removeClass('d-none');
            }
        });
    })

    $(document).on("click", "#add-course-btn", function (e) {
        e.preventDefault();
        const newFields = $('#course_template').html().replace(/NEW_RECORD/g, new Date().getTime());
        $('#sales_order_line_course').append(newFields);
        $('.remove-course-line-btn').removeClass('d-none');
        $('#sales_order_line_course .course-fields').each(function(index) {
            if (index === 0) {
                $(this).find('.remove-course-line-btn').addClass('d-none');
            } else {
                $(this).find('.remove-course-line-btn').removeClass('d-none');
            }
        });
    })

    $(document).on("click", "#add-product-btn", function (e) {
        e.preventDefault();
        const newFields = $('#product_template').html().replace(/NEW_RECORD/g, new Date().getTime());
        $('#sales_order_line_product').append(newFields);
        $('.remove-product-line-btn').removeClass('d-none');
        $('#sales_order_line_product .product-fields').each(function(index) {
            if (index === 0) {
                $(this).find('.remove-product-line-btn').addClass('d-none');
            } else {
                $(this).find('.remove-product-line-btn').removeClass('d-none');
            }
        });
    })
    
    $(document).on('click', '.remove-plan-line-btn', function(e) {
        e.preventDefault();
        const $field = $(this).closest(".plan-fields");
        const $destroyInput = $field.find('input[name*="_destroy"]');
        if ($destroyInput.length) {
        $destroyInput.val(1);
        $field.hide();
        } else {
        $field.remove();
        }
        calculateTotalPrice();
    });

    $(document).on('click', '.remove-course-line-btn', function(e) {
        e.preventDefault();
        const $field = $(this).closest(".course-fields");
        const $destroyInput = $field.find('input[name*="_destroy"]');
        if ($destroyInput.length) {
        $destroyInput.val(1);
        $field.hide();
        } else {
        $field.remove();
        }
        calculateTotalPrice();
    });

    $(document).on('click', '.remove-product-line-btn', function(e) {
        e.preventDefault();
        const $field = $(this).closest(".product-fields");
        const $destroyInput = $field.find('input[name*="_destroy"]');
        if ($destroyInput.length) {
        $destroyInput.val(1);
        $field.hide();
        } else {
        $field.remove();
        }
        calculateTotalPrice();
    });

    $('.sidebar-toggle').on('click', function () {
        if (window.innerWidth < 1200) {
            $('body').toggleClass('navbar-vertical-aside-closed-mode')
        }
        if ($('body').hasClass('navbar-vertical-aside-closed-mode')) {
            $('body').removeClass("overflow-hidden")
        } else {
            $('body').addClass("overflow-hidden")
        }
    });

    $('.checkout-name').on('keyup',function (){
       $('#checkout_form_checkout_url').val($(this).val().replace(/[^A-Z0-9]/gi,''))
    })

    $('.tour').on('click', function () {
        $.ajax({
            type: "GET",
            dataType: "script",
            url: '/tour/restart',
            data: {},
            success: function (data) {
            }
        });
    });

    checkedAllCheckbox('.all-checkbox');
    $(".select2").select2({
        width: '100%'
    });

    $('.select2-add').select2({
        allowClear: true,
        width: '100%',
        language: {
            noResults: function () {
                return `<a style="width: 100%" type="button" class="btn btn-primary add-record">+ Add New Items</a>`;
            }
        },
        escapeMarkup: function (markup) {
            return markup;
        }
    });

    $('.select2-add-custom')
        .select2()
        .on('select2:open', () => {
            $(".select2-results:not(:has(a))").append('<a href="/segments/new" data-remote="true" style="padding: 6px;height: 20px;display: inline-table;">Nieuw segment maken</a>');
        })

    $('#alias_modal').on('show', function () {
        $('#myInput').trigger('focus')
    })

    $('#alias_modal').modal('show')

    // $(".trix-content figure.attachment").closest("a").fancybox({
    //     helpers: {
    //         title : {
    //             type : 'float'
    //         }
    //     }
    // });

    function initializeFlatpickr() {
        $(".set-date").flatpickr({
            dateFormat: "Y-m-d",
            locale: "nl"
        });
    }

    initializeFlatpickr();

    $(".set-course-date").flatpickr({
        dateFormat: "Y-m-d",
        "locale": "nl"
    });

    $(".set-time").flatpickr({
        noCalendar: true,
        dateFormat: "H:i",
        enableTime: true,
        time_24hr: true
    });
    $('.scroll').click(function () {
        $('body').animate({
            scrollTop: eval($('#' + $(this).attr('target')).offset().top - 70)
        }, 1000);
    });

    $(document).on("change", ".change-plan, .change-partner", function () {
        const planId = $(".change-plan").val() || "All";
        const partnerId = $(".change-partner").val() || "All";
        const $downloadLink = $(".download-link");
        const currentUrl = new URL($downloadLink.attr("href"), window.location.origin);
        currentUrl.searchParams.set("plan_id", planId);
        currentUrl.searchParams.set("partner_id", partnerId);
        $downloadLink.attr("href", currentUrl.toString());
    });

    $(".change-month, .change-year, .change-plan, .change-partner").change(function () {
        var month = $("#date_month option:selected").text()
        var year = $("#date_year option:selected").text()
        var plan_id = $(".change-plan option:selected").val()
        var partner_id = $(".change-partner option:selected").val()
        console.log(partner_id);
        $.ajax({
            type: "GET",
            dataType: "script",
            url: '/dashboard',
            data: {month: month.split(' - ')[0], year: year, plan_id: plan_id, partner_id: partner_id},
            success: function (data) {
            }
        });
    });
    
    init_filepond_profile_pic();

    // if (App.isAngularJsApp() === false) {
    //     jQuery(document).ready(function() {
    //         TableDatatablesManaged.init();
    //     });
    // }
    // var oSTable
    $("table[role='datatable']").each(function (e) {
        if ($(this).data('role') === 'new_table') {
            oSTable = $(this).DataTable({
                dom: '"<\'row\'<\'col-sm-12\'tr>>" +"<\'row\'<\'col-sm-8\'p><\'col-sm-4\'l>>", ',
                "lengthMenu": [[10, 25, 50, 100], [10, 25, 50, 100]],
                bProcessing: true,
                bServerSide: true,
                bLengthChange: false,
                searching: false,
                pageLength: 10,
                bInfo: true,
                pagingType: 'input',
                "language": {
                    "thousands": ".",
                    "aria": {
                        "sortAscending": ": activate to sort column ascending",
                        "sortDescending": ": activate to sort column descending"
                    },
                    "emptyTable": "No data available in table",
                    "info": " ",
                    "infoEmpty": "No records found",
                    "infoFiltered": "",
                    "lengthMenu": "_MENU_",
                    "search": "",
                    "searchPlaceholder": "Zoeken...",
                    "zeroRecords": "No matching records found",
                    "paginate": {
                        "previous": "<i class=\"fas fa-chevron-left\"></i>",
                        "next": "<i class=\"fas fa-chevron-right\"></i>",
                        "last": "<i class=\"fas fa-chevron-double-right\"></i>",
                        "first": "<i class=\"far fa-chevron-double-left\"></i>"
                    },
                },
                // "ordering": false,
                "ordering": true,
                "order": [[0, "desc"]],
                "aoColumnDefs": [
                    {'bSortable': false, 'aTargets': [-1, 'no-sort']}
                ],
                sAjaxSource: $(this).data('source'),
                "infoCallback": function (settings, start, end, max, total, pre) {
                    return total + " results";
                },
                "fnDrawCallback": function (settings) {
                    var api = this.api();
                    var info = api.page.info();
                    
                    if (info.recordsTotal <= 10) {
                        $(".dataTables_paginate").hide();
                    } else {
                        $(".dataTables_paginate").show();
                    }
                }
            })
        }
        else
            {

                oSTable = $(this).DataTable({
                    "lengthMenu": [[10, 25, 50, 100], [10, 25, 50, 100]],
                    bProcessing: true,
                    bServerSide: true,
                    bLengthChange: true,
                    pageLength: 10,
                    bInfo: true,
                    "language": {
                        "thousands": ".",
                        "aria": {
                            "sortAscending": ": activate to sort column ascending",
                            "sortDescending": ": activate to sort column descending"
                        },
                        "emptyTable": "No data available in table",
                        "info": " ",
                        "infoEmpty": "No records found",
                        "infoFiltered": "(filtered1 from _MAX_ total records)",
                        "lengthMenu": "_MENU_",
                        "search": "Zoeken:",
                        "zeroRecords": "No matching records found",
                        "paginate": {
                            "previous": "Vorige",
                            "next": "Volgende",
                            "last": "Last",
                            "first": "First"
                        }
                    },
                    // "ordering": false,
                    "ordering": true,
                    "order": [[0, "desc"]],
                    "aoColumnDefs": [
                        {'bSortable': false, 'aTargets': [-1, 'no-sort']}
                    ],
                    sAjaxSource: $(this).data('source'),
                    "infoCallback": function (settings, start, end, max, total, pre) {
                        return total + " results";
                    }
                })
            }
    });

    window.initializeModalDataTable = function({ modalId, modalBodyId, tableId, ajaxSourceSelector, defaultOrderColumn }) {
        $(modalId).modal('show');

        if ($.fn.DataTable.isDataTable(tableId)) {
            $(tableId).DataTable().destroy();
            $(tableId).empty();
        }

        var table = $(tableId).DataTable({
            dom: "<'row'<'col-sm-12'tr>> + <'row'<'col-sm-8'p><'col-sm-4'l>>",
            lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
            bProcessing: true,
            bServerSide: true,
            bLengthChange: false,
            searching: true,
            pageLength: 10,
            bInfo: true,
            pagingType: 'input',
            language: {
            thousands: ".",
            aria: {
                sortAscending: ": activate to sort column ascending",
                sortDescending: ": activate to sort column descending"
            },
            emptyTable: "No data available in table",
            info: "",
            infoEmpty: "No records found",
            infoFiltered: "",
            lengthMenu: "_MENU_",
            search: "",
            zeroRecords: "No matching records found",
            paginate: {
                previous: "<i class='fas fa-chevron-left'></i>",
                next: "<i class='fas fa-chevron-right'></i>",
                last: "<i class='fas fa-chevron-double-right'></i>",
                first: "<i class='far fa-chevron-double-left'></i>"
            }
            },
            ordering: true,
            order: [[defaultOrderColumn || 0, "desc"]],
            aoColumnDefs: [
            { bSortable: false, aTargets: [-1, 'no-sort'] }
            ],
            sAjaxSource: $(ajaxSourceSelector).data('source')
        });

        if ( tableId === '#planUserDT') {
            $(".search-name").on('keyup', function () {
                if ($(this).val().length >= 2) {
                    table.ajax.url("/contacts.json?name=" + $('#search_name').val()).load()
                    document.querySelector('.user-count-plan').textContent = `Number of total users found on that search: ${table.page.info().recordsDisplay}`;
                } else {
                    table.ajax.url("/contacts.json?").load()
                    document.querySelector('.user-count-plan').textContent = `Number of total users: ${table.page.info().recordsTotal}`;
                }
            });
        }

        $('#search-data').on('keyup', function () {
            table.search(this.value).draw();
        });
    };

    $(".select-plan").change(function () {
        oSTable.ajax.url("/contacts.json?plan_id=" + $('#plan_id').val() + '&name=' + $('#search_name').val()).load()
    });
    
    $(".search-name").keyup(function () {
        if ($(this).val().length >= 2) {
            oSTable.ajax.url("/contacts.json?name=" + $('#search_name').val() + '&plan_id=' + $('#plan_id').val()).load()
        } else {
            oSTable.ajax.url("/contacts.json?").load()
        }
    });

    $(".search-question").keyup(function () {
        let url = "/survey_questions.json?survey_position_id=" + $(this).data("survey-position-id")
        if ($(this).val().trim().length >= 2) {
            oSTable.ajax.url(url += "&name=" + encodeURIComponent($(this).val().trim())).load();
        } else {
            oSTable.ajax.url(url).load()
        }
    });

    $(".lesson_search").keyup(function () {
        let url = "/online_course_lessons.json?online_course_id=" + $(this).data("online-course-id");
        if ($(this).val().trim().length >= 2) {
            url += "&name=" + encodeURIComponent($(this).val().trim());
        }
        oSTable.ajax.url(url).load();
    });
    
    $(".search_data").keyup(function () {
        let userCountElement = document.querySelector('.user-count');
        let partnerCountElement = document.querySelector('.partner-count');
        let userCountElementUser = document.querySelector('.user-count-user');
        if ($(this).val().length >= 2) {
            oSTable.ajax.url(`${$(this).parent().parent().next().find('table').data('source')}?name=${$(this).val()}`).load(() => {
                if (userCountElement) {
                    userCountElement.textContent = `Number of total users found on that search results: ${oSTable.ajax.json().unique_user_count}`;
                } else if (partnerCountElement) {
                    console.log(`${oSTable.page.info().recordsDisplay}`);
                    partnerCountElement.textContent = `Number of total partners found on that search results: ${oSTable.page.info().recordsDisplay}`;
                } else if (userCountElementUser) {
                    userCountElementUser.textContent = `Number of total users found on that search results: ${oSTable.page.info().recordsDisplay}`;
                }
            });
        } else {
            oSTable.ajax.url($(this).parent().parent().next().find('table').data('source')).load(() => {
                if (userCountElement) {
                    userCountElement.textContent = `Number of total users: ${oSTable.ajax.json().unique_user_count}`;
                } else if (partnerCountElement) {
                    partnerCountElement.textContent = `Number of total partners: ${oSTable.page.info().recordsTotal}`;
                } else if (userCountElementUser) {
                    userCountElementUser.textContent = `Number of total users: ${oSTable.page.info().recordsTotal}`;
                }  
            });
        }
    });
     
    $('.user-data').on('click', 'tbody tr td', function() {
        window.location.href = $(this).find("div").children().attr('href');
    });

    $(".select-active").change(function () {
        oSTable.ajax.url("/subscriptions.json?active=" + $(".select-active").is(':checked')).load()
    });

    $(document).on('keyup', '.check-price', function (event) {
        if ($(this).val().length >= 2) {
            if ($(this).val() <= 90) {
                $(this).parent().parent().next('div').find('input[type="checkbox"]').prop('checked', true);
            } else {
                $(this).parent().parent().next('div').find('input[type="checkbox"]').prop('checked', false);
            }
        }
    })

    $('#user_tags, #checkout_form_key_points').tagsinput({
        confirmKeys: [188, 13, 44],
        trimValue: true
    });

    $("#search_report").on("keyup", function () {
        $.ajax({
            type: "POST",
            dataType: "script",
            url: '/search_report',
            data: {search_query: $(this).val()},
            success: function (data) {
            }
        });
    });
    setTooltip()
    $('.off-app #copy-btn').hover(function(e){
        if ($('#checkout_form_checkout_url').val().length > 0) {
            setTooltip($(this), 'Click To Copy!');
        }
    });

    $("#copy-btn").click(function () {
        if ($('#checkout_form_checkout_url').val().length > 0){
        $(this).prev(".copy-url").val($('.url-field').html() + $('#checkout_form_checkout_url').val());
        var copyText = $(this).prev(".copy-url");
        copyText.attr("type", "text").select();
        document.execCommand("copy");
        copyText.attr("type", "hidden");
        setTooltip($(this), 'Copied!');
        }else{
            setTooltip($(this), 'Value is blank!');
        }
    });

        $(".select-status").change(function () {
            oSTable.ajax.url("/invoices.json?status=" + $('input[name=status-button]:checked').val()).load()
        });

        $(".select-status-tickets").change(function () {
            oSTable.ajax.url("/tickets.json?status=" + $('input[name=status-button]:checked').val()).load()
        });

        $(".select-flagged-user").click(function () {
            oSTable.ajax.url("/contacts.json?flag="+ true ).load()
        });
                  
        $(".open-menu").click(function () {
            $(".page-sidebar").toggleClass("show");
            $("body").toggleClass("menu-open");
        });

        $(".close-menu").click(function () {
            $(".page-sidebar").removeClass("show");
            $("body").removeClass("menu-open");
        });
        $('.interval-options form input[type=radio]').on('change', function () {
            $('.interval-options form').submit();
        });
        // $('.available-plans .col-lg-4 .description').matchHeight();
        // $('.download-items .col-lg-4 .portlet-title').matchHeight();
        // $('.download-items .col-lg-4 .portlet-body').matchHeight();
        // $('.download-items .col-lg-4 .portlet-title').matchHeight();
        // $('.download-items .col-lg-4 .portlet-body').matchHeight();
        // $('.updates .portlet-body').matchHeight();
        // $('.onsite-cources .col-lg-4 .portlet-body').matchHeight();
        $('#online_course_plug_pay_ids').tagsinput({
            confirmKeys: [188, 13, 44],
            trimValue: true
        });
        $('#survey_question_qus_choices').tagsinput({
            confirmKeys: [188, 13, 44],
            trimValue: true
        });
    });

    $(document).on("change", ".toggle-renew", function () {
        var confirm_box = confirm("Weet je zeker dat je je instellingen wilt veranderen?");
        if (confirm_box == true) {
            $.ajax({
                url: '/update_auto_renew',
                type: 'POST',
                dataType: 'script',
                data: {current_subscription: {auto_renew: $(this).is(':checked')}},
                success: function (result) {
                }
            });
        } else {
            $(this).prop("checked", !$(this).is(':checked'));
        }
    });
 
      
    $(document).on("change", ".chk-qus-choice", function () {
        if ($("input[name='" + $(this).attr('name') + "']:checked").length == 0) {
            $("input[name='" + $(this).attr('name') + "']").attr("required", true)
        } else {
            $("input[name='" + $(this).attr('name') + "']").attr("required", false)
        }
    });

    $(document).on("click", ".sale-check", function () {
        if ($("#product_is_sale").is(':checked')) {
            $('.sale-price').removeClass('d-none')
            $('#product_sale_price').attr("required", true);
        } else {
            $('.sale-price').addClass('d-none')
            $('#product_sale_price').attr("required", false);
        }
    });

    $(document).on("click", ".add-record", function () {
        $('#oldInstrumentModal').modal('show');
        $("#instrument_display_name").val($('.select2-search__field').val())
        console.log($('.select2-add .select2-search__field').val())
    });

    function checkedAllCheckbox(checkedAllCheckboxElem) {
        $(checkedAllCheckboxElem).each(function () {
            var mainObj = $(this)
            var subCheckboxElem = $('.' + mainObj.data('chk-class'));
            mainObj.on("click", function () {
                subCheckboxElem.prop("checked", mainObj.is(':checked'));
            });
        });
    }

    export function portfolioGraph(keys, values) {
        const ctx = document.getElementById('myChart').getContext('2d');
        const myChart = new Chart(ctx, {
            type: 'line',
            data: {
                datasets: [{
                    label: 'stock',
                    data: values,
                    borderColor: ['#2E3192'],
                    fill: false,
                    borderWidth: 3,
                    tension: 0.1
                }],
                labels: keys
            },

            options: {
                plugins: {
                    legend: {
                        display: false
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    enabled: false
                },
                scales: {
                    x: {
                        grid: {
                            display: false
                        },
                        display: true,

                    },
                    y: {
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            suggestedMin: 0,
                            callback: function (value) {
                                return value + "%"
                            },
                        }
                    }
                },
                elements: {
                    line: {
                        borderWidth: 3
                    },
                    point: {
                        radius: 0
                    }
                }
            }
        });
    }

    export function  init_filepond_profile_pic() {
        $(".filepond-profile-pic").each(function () {
            if ($(this).data("name")) {
                createprofilePoster(
                    this,
                    $(this).data("name"),
                    $(this).data("size"),
                    $(this).data("type"),
                    $(this).data("url"),
                    $(this).data("remove-url"),
                    $(this).data("id")
                );
            } else {
                FilePond.create(this, {
                        labelIdle: 'Select <span class="filepond--label-action">image</span>',
                        imagePreviewHeight: 170,
                        imageCropAspectRatio: '1:1',
                        imageResizeTargetWidth: 200,
                        imageResizeTargetHeight: 200,
                        stylePanelLayout: 'compact circle',
                        styleLoadIndicatorPosition: 'center bottom',
                        styleButtonRemoveItemPosition: 'center bottom'
                    }
                );
            }
        });
    }

    function createprofilePoster(input, name, size, type, url, delete_url, item_id) {
        FilePond.create(input, {
            name: "filepond",
            imagePreviewHeight: 170,
            imageCropAspectRatio: '1:1',
            imageResizeTargetWidth: 200,
            imageResizeTargetHeight: 200,
            stylePanelLayout: 'compact circle',
            styleLoadIndicatorPosition: 'center bottom',
            styleButtonRemoveItemPosition: 'center bottom',
            files: [{
                options: {
                    file: {
                        name: name,
                        size: size,
                        type: type
                    },
                    metadata: {
                        poster: url
                    }
                }
            }]
        });
        $(".filepond-profile-pic").on("FilePond:removefile", function (e) {
            var id = item_id;
            if (id) {
                $.ajax({
                    url: delete_url,
                    type: "POST",
                    datatype: "Script",
                    data: {id: id},
                    success: function (result) {
                    }
                });
            }
            init_filepond_profile_pic();
        });
    }

// $( window ).resize(function() {
//     setSidebarClass()
// });
    function setSidebarClass() {
        if (window.innerWidth < 1200) {
            $('body').addClass('navbar-vertical-aside-closed-mode')
        } else {
            $('body').removeClass('navbar-vertical-aside-closed-mode')
            new HSSideNav('.js-navbar-vertical-aside').init()
        }
    }
function setTooltip(btn, message) {
    $(btn).tooltip('show')
        .attr('data-bs-original-title', message)
        .tooltip('show');
}

document.addEventListener("turbo:load", () => {
    const container = document.querySelector("#chat-messages-channel");
    if (!container) return;

    scrollToBottom();

    const observer = new MutationObserver(() => {
      scrollToBottom();
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });
    createFilePicker();
  });

function scrollToBottom() {
    const box = document.querySelector("#messages");
    if (!box) return;
    box.scrollTop = box.scrollHeight;
};

document.addEventListener('turbo:submit-end', (e)=> {
	e.stopPropagation();
	setTimeout(() => {
		const messageBox = document.getElementById('message-box')
		if (messageBox) {
			createFilePicker();
			$('#chat-form').on("turbo:submit-start", ()=> {
				$('#chat_input').val('');
				$('#attachments').empty();
				scrollToBottom();
			});
			$('#chat-form').on("turbo:submit-end", ()=> {
				$('#chat_input').val('');
				$('#attachments').empty();
				scrollToBottom();
			});
		}
	}, 100);
});

function createFilePicker() {
  const trigger = document.getElementById("file-picker-trigger");
  const fileInput = document.getElementById("file-input");
  const attachmentsDiv = document.getElementById("attachments");
  const form = document.getElementById("chat-form");

  if (!trigger || !fileInput || trigger.dataset.bound === "true") return;
  trigger.dataset.bound = "true";

  let selectedFiles = [];

  function syncFileInput() {
    const dataTransfer = new DataTransfer();
    selectedFiles.forEach(f => dataTransfer.items.add(f));
    fileInput.files = dataTransfer.files;
  }

  trigger.addEventListener("click", () => {
    fileInput.click();
  });

  fileInput.addEventListener("change", (e) => {
    const files = Array.from(e.target.files);

    files.forEach(file => {
      selectedFiles.push(file);

      const fileWrapper = document.createElement("div");
      fileWrapper.classList.add("position-relative", "d-inline-block");
      fileWrapper.style.width = "80px";
      fileWrapper.style.height = "80px";

      let preview;
      if (file.type.startsWith("image/")) {
        preview = document.createElement("img");
        preview.src = URL.createObjectURL(file);
        preview.classList.add("w-100", "h-100", "rounded", "object-fit-cover");
      } else {
        preview = document.createElement("div");
        preview.classList.add("d-flex", "align-items-center", "justify-content-center",
                              "bg-light", "border", "rounded");
        preview.style.width = "100%";
        preview.style.height = "100%";
        preview.style.fontSize = "12px";
        preview.style.textAlign = "center";
        preview.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
               fill="currentColor" class="bi bi-file-earmark-text" viewBox="0 0 16 16">
            <path d="M5 7h6v1H5V7zm0 2h6v1H5V9z"/>
            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5z"/>
          </svg>
          <div style="font-size:10px;margin-top:2px;">${file.name.split(".").pop().toUpperCase()}</div>
        `;
      }

      const removeBtn = document.createElement("button");
      removeBtn.innerHTML = "&times;";
      removeBtn.classList.add("btn", "btn-danger", "position-absolute", "top-0", "end-0",
                              "m-1", "p-1", "rounded-circle", "d-flex",
                              "align-items-center", "justify-content-center");
      removeBtn.style.width = "25px";
      removeBtn.style.height = "25px";
      removeBtn.type = "button";

      removeBtn.addEventListener("click", () => {
        attachmentsDiv.removeChild(fileWrapper);
        selectedFiles = selectedFiles.filter(f => f !== file);
        syncFileInput();
      });

      fileWrapper.appendChild(preview);
      fileWrapper.appendChild(removeBtn);
      attachmentsDiv.appendChild(fileWrapper);
    });

    syncFileInput();
    fileInput.value = "";
  });

  form.addEventListener("submit", () => {
    syncFileInput();
  });
}
